import { useSubscriptionPlanContext } from '../../../../subscriptionPlans/context';
import { CTA_ID } from './constants';

export const usePlanSelector = ({ onCtaClick, navigateOnSelect = true }) => {
  const { setSelectedOffer } = useSubscriptionPlanContext();
  const handleSelectPlan = (e, planId) => {
    setSelectedOffer(planId);

    if (navigateOnSelect) {
      handleCtaNavigate(e);
    }
  };

  const handleCtaNavigate = e => onCtaClick(e, CTA_ID);

  return {
    handleSelectPlan,
    handleCtaNavigate,
  };
};



// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/hooks.js